import FormLayout from './src/form-layout.vue'

FormLayout.install = function(Vue) {
  Vue.component(FormLayout.name, FormLayout)
}

export default FormLayout
